import Analytics from 'analytics-node';

var id = 0;

function _classPrivateFieldLooseKey(name) {
  return "__private_" + id++ + "_" + name;
}

function _classPrivateFieldLooseBase(receiver, privateKey) {
  if (!Object.prototype.hasOwnProperty.call(receiver, privateKey)) {
    throw new TypeError("attempted to use private field on non-instance");
  }

  return receiver;
}

var _writeKey = /*#__PURE__*/_classPrivateFieldLooseKey("writeKey");

var CbhSegment = /*#__PURE__*/function () {
  // @params: writeKey: string =>  your write key for segment source destination 
  function CbhSegment(writeKey) {
    Object.defineProperty(this, _writeKey, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldLooseBase(this, _writeKey)[_writeKey] = writeKey;
  }
  /*************************
  * CBH-SEGMENT PROPERTIES *
  **************************/


  var _proto = CbhSegment.prototype;

  /******************
  * PRIVATE METHODS *
  ******************/
  // @usage: this.identify()
  // @returns: Segment Instance
  // @params:  none
  _proto.segment = function segment() {
    return new Analytics(_classPrivateFieldLooseBase(this, _writeKey)[_writeKey]);
  }
  /******************
  * PUBLIC METHODS *
  ******************/
  // @usage: Instance.identify(payload)
  // @returns: true || Error Object with stack trace
  // @params:  Object{ userId: string|number, traits: ITraits }
  ;

  _proto.identify = function identify(payload) {
    try {
      // identify call to segment for new user
      this.segment().identify(payload);
      return true;
    } catch (error) {
      throw new Error(error);
    }
  } // @usage: Instance.track(payload)
  // @returns: true || Error Object with stack trace
  // @params:  userId: string|number, event: string, properties: ITraits
  ;

  _proto.track = function track(userId, event, properties) {
    try {
      // Tracking call to segment for identified user
      this.segment().track({
        userId: userId,
        event: event,
        properties: properties
      });
      return true;
    } catch (error) {
      throw new Error(error);
    }
  };

  return CbhSegment;
}();

export { CbhSegment };
//# sourceMappingURL=cbh-segment.esm.js.map
